// Session partagée entre les backoffices JTS (même format que widesk-core/tools/cookie.ts) :
// le token est découpé en cookies `<nom>[i]` + `<nom>-size`, posés sur le domaine parent.

// Sur le staging, tous les environnements (dev, demo, preproduction) partagent le domaine parent stonecode.io :
// le nom des cookies inclut le client et l'environnement pour ne pas mélanger leurs tokens (ex : "jts_dev_token").
// En production, les noms restent "token" / "refresh_token". Même règle que RH, shop, gespass, mon-compte et site public.
const getCookiePrefix = (): string => {
	const match = window.location.hostname.match(/^(dev|demo|preproduction)-/);

	return match ? `jts_${match[1]}_` : '';
};

export const SHARED_TOKEN_KEY = `${getCookiePrefix()}token`;
export const SHARED_REFRESH_TOKEN_KEY = `${getCookiePrefix()}refresh_token`;

const CHUNK_SIZE = 4000;
const EXPIRATION_MS = 3600000 * 24 * 7;

// Ne gère pas les extensions à plusieurs points (.co.uk...)
const getCurrentDomain = (): string => {
	const hostname = window.location.hostname;

	if (hostname === 'localhost') {
		return 'localhost';
	}

	const parts = hostname.split('.');

	return parts.slice(-2).join('.');
};

interface Cookie {
	name: string;
	value: string;
}

const getCookies = (): Cookie[] => document.cookie.split(';').map(str => {
	const [name = '', value = ''] = str.split('=');

	return {name: name.trim(), value};
});

const getCookieValue = (cookies: Cookie[], name: string): string | undefined => {
	const cookie = cookies.find(c => c.name === name);

	return cookie ? cookie.value : undefined;
};

export function removeSharedItem(name: string) {
	const domain = getCurrentDomain();
	const size = Number(getCookieValue(getCookies(), `${name}-size`)) || 0;
	const expired = 'Thu, 01 Jan 1970 00:00:01 GMT';

	document.cookie = `${name}-size=; Path=/; Domain=${domain}; Expires=${expired};`;

	for (let i = 0; i < size; i++) {
		document.cookie = `${name}[${i}]=; Path=/; Domain=${domain}; Expires=${expired};`;
	}
}

export function getSharedItem(name: string): string | null {
	const cookies = getCookies();
	const size = Number(getCookieValue(cookies, `${name}-size`)) || 0;

	let result = '';

	for (let i = 0; i < size; i++) {
		const chunk = getCookieValue(cookies, `${name}[${i}]`);

		if (!chunk) {
			removeSharedItem(name);

			return null;
		}

		result += chunk;
	}

	return result || null;
}

export function setSharedItem(name: string, value: string) {
	removeSharedItem(name);

	const domain = getCurrentDomain();
	const chunks = value.match(new RegExp(`.{1,${CHUNK_SIZE}}`, 'g')) || [];
	const expires = new Date(Date.now() + EXPIRATION_MS).toString();

	chunks.forEach((chunk, index) => {
		document.cookie = `${name}[${index}]=${chunk}; Path=/; Domain=${domain}; Expires=${expires};`;
	});

	document.cookie = `${name}-size=${chunks.length}; Path=/; Domain=${domain}; Expires=${expires};`;
}
